import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import {
  PixelBreadcrumbs,
  PixelDateRangePicker,
  PixelPageContainer,
  PixelTable,
  PixelTag,
  PixelTopBar,
  Section,
  SectionActions,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'

import { getInventoryRequests } from 'utils/api-routes.util'

const breadcrumbs = [
  {
    name: 'Orders',
    active: false,
    link: '/orders',
  },
  {
    name: 'Inventory Requests',
    active: true,
  },
]

const columns = [
  {
    dataKey: 'request_id',
    name: 'Request',
    sortable: true,
    selector: (row) => row.request_id || '--',
  },
  {
    dataKey: 'status',
    name: 'Status',
    sortable: true,
    selector: (row) => <PixelTag>{row.status}</PixelTag>,
  },
  {
    dataKey: 'total_amount',
    name: 'Total',
    sortable: true,
    selector: (row) => row.total_amount || '--',
  },
  {
    dataKey: 'total_discount',
    name: 'Discount ',
    sortable: true,
    selector: (row) => row.total_discount || '--',
  },
  {
    dataKey: 'net_value',
    name: 'Net',
    sortable: true,
    selector: (row) => row.net_value || '--',
  },
  {
    dataKey: 'total_shipping',
    name: 'Shipping ',
    sortable: true,
    selector: (row) => row.total_shipping || '--',
  },
  {
    dataKey: 'total_receivable',
    name: 'Receivable Total',
    sortable: true,

    selector: (row) => row.total_receivable || '--',
  },
  {
    dataKey: 'total_orders',
    name: 'Orders By',
    sortable: true,

    selector: (row) => row.total_orders || '--',
  },
  {
    dataKey: 'dispatch_id',
    name: 'Dispatch',
    sortable: true,
    selector: (row) => row.dispatch_id || '--',
  },
  {
    dataKey: 'courier_name',
    name: 'Courier Total',
    sortable: true,
    style: {
      color: '#f44336',
    },
    selector: (row) => row.courier_name || '--',
  },
  {
    dataKey: 'created_at',
    name: 'Date By',
    sortable: true,
    style: {
      color: '#2196f3',
    },
    selector: (row) => row.created_at || '--',
  },
  {
    dataKey: 'created_by',
    name: 'Created',
    sortable: true,
    selector: (row) => row.created_by || '--',
  },
]

const StockOut = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [data, setData] = React.useState<any>([])

  const [filters, setFilters] = React.useState<{
    start_date: Date
    end_date: Date
  }>({
    start_date: new Date(),
    end_date: new Date(),
  })
  const [tableLoading, setTableLoading] = React.useState(false)

  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)
  React.useEffect(() => {
    getOrders(formateDate(filters))
  }, [])

  const formateDate = (filters) => {
    return {
      sdate: moment(filters.start_date).format('YYYY-MM-DD'),
      edate: moment(filters.end_date).format('YYYY-MM-DD'),
    }
  }

  React.useEffect(() => {
    const params: any = searchParams

    if (params.sdate) setFilters(params)
  }, [])

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div style={{ paddingBottom: '40px', width: '30%' }}>
        <PixelDateRangePicker
          month={2}
          ranges={{
            start_date: new Date(filters.start_date),
            end_date: new Date(filters.end_date),
          }}
          onApply={() => {
            getOrders(formateDate(filters))
          }}
          onChange={(e) => {
            setFilters({
              ...filters,
              start_date: e.range1.startDate,

              end_date: e.range1.endDate,
            })
            setResetPaginationToggle(true)
          }}
        />
      </div>
    )
  }, [filters, resetPaginationToggle])

  const getOrders = (filter) => {
    setTableLoading(true)
    getInventoryRequests(filter).subscribe((res: AjaxResponse<any>) => {
      setData(res.response.data)
      setTableLoading(false)
    })
  }

  const onRowClicked = (rowData) => {
    navigate(`/orders/stock-out/${rowData.request_id}`)
  }
  return (
    <>
      <PixelTopBar>
        <PixelBreadcrumbs data={breadcrumbs} />
        <SectionActions></SectionActions>
      </PixelTopBar>
      <PixelPageContainer>
        <Section>
          <SectionContent>
            <PixelTable
              dense
              pagination={true}
              columns={columns}
              progressPending={tableLoading}
              data={data}
              subHeaderComponent={subHeaderComponentMemo}
              paginationResetDefaultPage={resetPaginationToggle}
              highlightOnHover={true}
              isSearchable={true}
              pointerOnHover={true}
              onRowClicked={onRowClicked}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default StockOut
